var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9464 8.28494L2.18021 5.5654C1.87291 5.26328 1.38015 5.26328 1.07284 5.5654C0.758059 5.87488 0.758059 6.38229 1.07284 6.69177L4.24534 9.81076C4.63444 10.1933 5.25837 10.1933 5.64747 9.81076L13.9272 1.67071C14.2419 1.36124 14.2419 0.853822 13.9272 0.544346C13.6199 0.242226 13.1271 0.242226 12.8198 0.544346L4.9464 8.28494Z",
    fill: "#6C9DF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgree);
export default __webpack_public_path__ + "static/media/agree.c7aa9869.svg";
export { ForwardRef as ReactComponent };